import breakpoints from './breakpoints';

export default {
    mobile: `screen and (max-width: ${breakpoints.mediumDevices-1}px)` ,
    extraSmallDevices: `screen and (max-width: ${breakpoints.smallDevices-1}px)` ,
    smallDevices: `screen and (min-width: ${breakpoints.smallDevices}px)`,
    mediumDevices: `screen and (min-width: ${breakpoints.mediumDevices}px)`,
    largeDevices: `screen and (min-width: ${breakpoints.largeDevices}px)`,
    extraLargeDevices: `screen and (min-width: ${breakpoints.extraLargeDevices})px`
}